export { AnswerTheQuestionOfDictationMutation } from './answer-the-question-of-dictation';
export { NextQuestionOfDictationMutation } from './next-question-of-dictation';
export { PrevQuestionOfDictationMutation } from './prev-question-of-dictation';
export { StartDictationByEventMutation } from './start-dictation-by-event';
export { StopDictationByEventMutation } from './stop-dictation-by-event';
